import { Moment } from '@intelipost-js/secure-providers';

export default {
  filters: {
    utcDate: (value, format = 'DD/MM/YYYY') => {
      if (!value) return null;
      const date = Moment(value);
      return date.isValid() ? date.utc().format(format) : value;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/utils/UTCDateMixin.js